exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (min-width: 992px) {\n.terms-page[data-v-c26be944] {\r\n    background-color: var(--color-blue-medium)\n}\n}\n.terms-page .terms input[data-v-c26be944]{\r\n      display: inline-block;\r\n      vertical-align: middle;\r\n      margin-right: 5px;\n}\n.terms-page .terms a[data-v-c26be944]{\r\n      color: var(--color-green);\r\n      display: inline-block;\r\n      vertical-align: middle;\n}\r\n", ""]);

// exports
